/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveLPTokensDetailsFetcher,
  ICurveLPTokensDetailsFetcherInterface,
} from "../ICurveLPTokensDetailsFetcher";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "curveLPTokensDetailsFetcherPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ICurveLPTokensDetailsFetcher__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveLPTokensDetailsFetcherInterface {
    return new utils.Interface(_abi) as ICurveLPTokensDetailsFetcherInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveLPTokensDetailsFetcher {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveLPTokensDetailsFetcher;
  }
}
